module.exports = __webpack_public_path__ + "static/media/api.66b8f085.png";